/**
 * Brera · Búsqueda mientras se escribe (snippets/header-search.liquid)
 * Pide /search/suggest?section_id=predictive-search con los tipos y la cantidad de Configuración del tema → Búsqueda
 * y pone el HTML de sections/predictive-search.liquid en el panel. Guarda las respuestas para no repetir pedidos.
 * Flechas ↑ ↓ para moverse por los resultados, Enter abre el elegido, Esc cierra (lo maneja el header).
 */
(() => {
  if (window.BreraSearch) return;
  window.BreraSearch = true;

  const root = (window.Brera && window.Brera.routes && window.Brera.routes.root) || '/';

  const init = (box) => {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';

    const input = box.querySelector('[data-predictive-input]');
    const start = box.querySelector('[data-predictive-start]');
    const target = box.querySelector('[data-predictive-target]');
    const clear = box.querySelector('[data-predictive-clear]');
    const form = input && input.form;
    if (!input || !target) return;

    const cache = new Map();
    let timer;
    let controller;
    let active = -1;

    const options = () => [...target.querySelectorAll('[data-predictive-option]')];

    const setActive = (i) => {
      const list = options();
      list.forEach((el) => el.classList.remove('is-active'));
      active = i;
      if (i >= 0 && list[i]) {
        list[i].classList.add('is-active');
        list[i].scrollIntoView({ block: 'nearest' });
      }
    };

    const show = (html) => {
      target.innerHTML = html;
      target.hidden = false;
      target.classList.remove('is-loading');
      if (start) start.hidden = true;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    };

    const reset = () => {
      if (controller) controller.abort();
      target.hidden = true;
      target.innerHTML = '';
      if (start) start.hidden = false;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    };

    const fetchResults = async (q) => {
      const key = q.toLowerCase();
      if (cache.has(key)) { show(cache.get(key)); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      target.classList.add('is-loading');

      const params = new URLSearchParams({
        q,
        section_id: 'predictive-search',
        'resources[type]': box.dataset.types || 'product',
        'resources[limit]': box.dataset.limit || '4',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': box.dataset.unavailable || 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor,tag',
      });

      try {
        const res = await fetch(`${root}search/suggest?${params}`, { signal: controller.signal });
        if (!res.ok) throw new Error(res.status);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const results = doc.querySelector('[data-predictive-results]');
        const html = results ? results.innerHTML : '';
        cache.set(key, html);
        if (input.value.trim().toLowerCase() === key) show(html);
      } catch (err) {
        if (err.name !== 'AbortError') target.classList.remove('is-loading');
      }
    };

    input.addEventListener('input', () => {
      const q = input.value.trim();
      if (clear) clear.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length < 2) { reset(); return; }
      timer = setTimeout(() => fetchResults(q), 220);
    });

    clear?.addEventListener('click', () => {
      input.value = '';
      clear.hidden = true;
      reset();
      input.focus();
    });

    input.addEventListener('keydown', (e) => {
      const list = options();
      if (e.key === 'ArrowDown' && list.length) {
        e.preventDefault();
        setActive(active + 1 >= list.length ? 0 : active + 1);
      } else if (e.key === 'ArrowUp' && list.length) {
        e.preventDefault();
        setActive(active - 1 < 0 ? list.length - 1 : active - 1);
      } else if (e.key === 'Enter' && active >= 0 && list[active]) {
        e.preventDefault();
        window.location.href = list[active].href;
      }
    });

    // Sin texto no se envía el formulario
    form?.addEventListener('submit', (e) => {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });
  };

  const run = () => document.querySelectorAll('[data-predictive-search]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
